/**
 * Acronyms giữ NGUYÊN chữ hoa khi title-case (không hạ về "Tnhh"/"Tlc").
 * Bổ sung khi gặp acronym mới; so khớp không phân biệt dấu chấm/hoa-thường.
 */
const KEEP_UPPERCASE_ACRONYMS: ReadonlySet<string> = new Set([
  'TNHH', 'MTV', 'TLC', 'CP', 'DNTN', 'HTX', 'XNK', 'TM', 'DV', 'TMDV',
  'JSC', 'LLC', 'CTY', 'VN', 'USA',
])

/**
 * Title-case a proper name that is stored UPPERCASE in the DB (e.g. counterparty
 * names from `cp_vn`). Capitalises the first letter of each word, lower-cases the
 * rest. Unicode-aware so Vietnamese diacritics survive (CÔNG TY → Công Ty).
 *
 * Acronyms trong `KEEP_UPPERCASE_ACRONYMS` giữ nguyên hoa (TNHH/MTV/TLC…).
 *
 * Display-only: never mutate the stored value, only the rendered string.
 * Splits on whitespace but keeps original separators (spaces/tabs) intact.
 */
export function titleCaseName(value: unknown): string {
  if (value == null) return ''
  const s = String(value)
  if (!s) return ''
  return s.replace(/\S+/g, (word) => {
    // Bỏ ký tự không phải chữ/số ở đầu-cuối (dấu chấm, ngoặc) để so khớp acronym.
    const core = word.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '')
    if (core && KEEP_UPPERCASE_ACRONYMS.has(core.toLocaleUpperCase())) {
      return word.toLocaleUpperCase()
    }
    const lower = word.toLocaleLowerCase()
    return lower.charAt(0).toLocaleUpperCase() + lower.slice(1)
  })
}
